module.exports = __webpack_public_path__ + "img/code.9d196ee1.png";